export default __webpack_public_path__ + "static/media/01-large.fa9d7f2c.jpg";